import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { IDynamicTableColumn } from '@app/shared/interfaces/dynamic-table.interface';
import { IPagination } from '@app/shared/interfaces/mainTable.interface';
import { StockyEntryService } from '../../services/stocky-entry.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ModalDevolutionReasonsComponent } from '@app/shared/components/modal-devolution-reasons/modal-devolution-reasons.component';
@Component({
  selector: 'app-charging',
  templateUrl: './charging.component.html',
  styleUrls: ['./charging.component.sass'],
})
export class Charging implements OnInit {
  constructor(
    private dialog: MatDialog,
    private stockyEntryService: StockyEntryService,
    private _toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    const auth = JSON.parse(sessionStorage.getItem('auth') || '{}');

    if (auth?.name) {
      const names = auth.name.trim().split(' ');

      this.userName = names.slice(0, 2).join(' ');
    }

    this.getChargingResume();
    this.getChargingLotsWaiting();
    this.getCharging();
  }

  userName: string = '';

  lots: any[] = [];

  selectedLots: any[] = [];

  lotSearch = '';

  tableData: any[] = [];

  get totalQuantity(): number {
    return this.tableData.reduce((sum, item) => sum + (parseInt(item.quantidade) || 0), 0);
  }
  displayedColumns: string[] = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  actionColumn!: IDynamicTableColumn;

  serverPagination: IPagination | undefined;

  pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
  };

  tableColumns: IDynamicTableColumn[] = [
    {
      columnDef: 'numero',
      header: 'Lote',
    },
    {
      columnDef: 'quantidade',
      header: 'Qtd.',
    },
    {
      columnDef: 'dataFechamento',
      header: 'Fechamento',
    },

    {
      columnDef: 'dataEntrega',
      header: 'Entrega',
    },
  ];

  get filteredLots(): any[] {
    const searchTerm = this.lotSearch.trim();

    if (!searchTerm) {
      return this.lots;
    }

    return this.lots.filter((lot) => String(lot.numero).includes(searchTerm));
  }

  removeQuantity: number = 0;

  loadingCount: number = 0;

  dockCount: number = 0;

  waitingCount: number = 0;

  lotsLoading: any[] = [];

  addLots(): void {
    const mappedLots = this.selectedLots
      .filter((lot) => !this.tableData.some((item) => item.id === lot.id))
      .map((lot) => ({
        id: lot.id,
        numero: lot.numero,
        quantidade: `${lot.quantidade} unidades`,
        dataFechamento: this.formatDate(lot.dataFechamento),
        dataEntrega: this.formatDate(lot.dataEntrega),
      }));
    this.tableData = [...this.tableData, ...mappedLots];

    this.pagination.totalItems = this.tableData.length;
  }

  handleAction(event: any): void {
    if (event.action === 'remove') {
      this.removeLot(event.row);
    }
  }

  removeLot(row: any): void {
    this.tableData = this.tableData.filter((item) => item.id !== row.id);

    this.pagination.totalItems = this.tableData.length;
  }

  onPageChange(event: any): void {
    this.pagination.currentPage = event.currentPage;
    this.pagination.pageSize = event.pageSize;
    this.getChargingResume();
    this.getChargingLotsWaiting();
  }

  getChargingResume(): void {
    this.stockyEntryService.getChargingResume().subscribe({
      next: (response) => {
        const data = response;
        this.dockCount = data?.emDoca ?? 0;
        this.waitingCount = data?.lotesAguardandoReceber ?? 0;
        this.loadingCount = data?.emCarregamento ?? 0;
      },
      error: (error) => {
        this._toastrService.error(error.err[0] ?? 'Erro ao buscar resumo do carregamento.');
      },
    });
  }

  getChargingLotsWaiting(): void {
    this.stockyEntryService.getLotsWaiting().subscribe({
      next: (response) => {
        const lots = response ?? [];
        this.lots = lots.map((lot: any) => ({
          id: lot.id,
          numero: lot.numero,
          quantidade: lot.quantidade,
          dataFechamento: lot.dataFechamento,
          dataEntrega: lot.dataEntrega,
        }));
      },
      error: (error) => {
        this._toastrService.error(error.err[0] ?? 'Erro ao buscar lotes aguardando recebimento.');
      },
    });
  }

  getCharging(): void {
    this.stockyEntryService.getLotsLoading().subscribe({
      next: (response) => {
        const lots = response?.data ?? [];
        this.lotsLoading = lots.map((lot: any) => ({
          id: lot.id,
          numero: lot.numero,
          quantidade: lot.quantidade,
          dataCarregamento: lot.dataCarregamento,
        }));
      },
      error: (error) => {
        this._toastrService.error(error.errors[0] ?? 'Erro ao buscar lotes em carregamento.');
      },
    });
  }
  receiveLots(): void {
    const payload = {
      loteIds: this.tableData.map((lot) => lot.id),
    };
    this.stockyEntryService.receiveLots(payload).subscribe({
      next: (response) => {
        this._toastrService.success('Lotes recebidos com sucesso.');
        this.selectedLots = [];
        this.tableData = [];
        this.getChargingResume();
        this.getChargingLotsWaiting();
        this.getCharging();
      },
      error: (error) => {
        this._toastrService.error(error.errors[0] ?? 'Erro ao receber os lotes.');
      },
    });
  }
  removeTradesFromLoading(): void {
    if (!this.removeQuantity || this.removeQuantity <= 0) {
      this._toastrService.warning('Informe uma quantidade válida.');
      return;
    }

    if (this.removeQuantity > this.loadingCount) {
      this._toastrService.error('Quantidade maior que o saldo em carregamento.');
      return;
    }

    const payload = {
      quantidade: Number(this.removeQuantity),
    };

    this.stockyEntryService.removeTrades(payload).subscribe({
      next: (response) => {
        this._toastrService.success('Lote retirado com sucesso!');
        this.removeQuantity = 0;
        this.getChargingResume();
        this.getChargingLotsWaiting();
        this.getCharging();
      },
      error: (error) => {
        this._toastrService.error(error.errors[0] ?? 'Erro ao retirar o lote do carregamento.');
      },
    });
  }

  returnLots(): void {
    if (!this.tableData.length) {
      return;
    }

    this._toastrService.success('Lotes devolvidos com sucesso.');

    this.tableData = [];
    this.selectedLots = [];
  }

  reloadPage() {
    this.getChargingResume();
    this.getChargingLotsWaiting();
    this.getCharging();
  }

  formatDate(dateString: string | null): string {
    if (!dateString) {
      return '-';
    }

    const date = new Date(dateString);

    return date.toLocaleDateString('pt-BR');
  }

  removeSelectedLot(lotToRemove: any): void {
    this.selectedLots = this.selectedLots.filter((lot) => lot.id !== lotToRemove.id);
  }

  openCheckList(): void {
    const dialogRef = this.dialog.open(ModalDevolutionReasonsComponent, {
      width: '65%',
      data: this.selectedLots,
      panelClass: 'devolution-dialog',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.reloadPage();
        this.selectedLots = [];
        this.tableData = [];
      }
    });
  }
}
